var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    transform: "matrix(1 0 0 -1 0 40)",
    fill: "#E6E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2004 19.9997V17.2013C11.2004 13.632 11.2004 11.8472 12.1751 10.6385C12.372 10.3943 12.5944 10.1718 12.8386 9.97492C14.0474 9.00026 15.8321 9.00026 19.4014 9.00026C20.1775 9.00026 20.5655 9.00026 20.9209 9.12566C20.9948 9.15184 21.0672 9.18175 21.1379 9.21563C21.4779 9.3782 21.7522 9.65253 22.301 10.2013L27.5109 15.4113C28.1467 16.0471 28.4646 16.3651 28.6321 16.7693C28.7995 17.1735 28.7995 17.6232 28.7995 18.5224V22.1996C28.7995 26.3478 28.7995 28.4219 27.5109 29.7105C26.3459 30.8755 24.5389 30.9873 21.1379 30.998M21.0999 9.55024V10.1002C21.0999 13.2114 21.0999 14.7669 22.0665 15.7335C23.033 16.6999 24.5885 16.6999 27.6996 16.6999H28.2496",
    stroke: "#3D4AF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6002H11.2004M15.6002 31V22.2004",
    stroke: "#3D4AF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/file_add.5ab1de02b1878eebeea2436ea145f81b.svg";
export { ForwardRef as ReactComponent };